module.exports = __webpack_public_path__ + "img/bw.d9e5e45f.svg";